import React from "react";

const InputField = ({
    label,
    name,
    type = "text",
    placeholder,
    value,
    onChange,
    icon: Icon,
}) => {
    const isRequired = label.includes("*");

    return (
        <div className="mb-4">
            <label htmlFor={name} className="block text-gray-700 font-medium mb-1">
                {label.replace("*", "").trim()}
                {isRequired && <span className="text-red-500 ml-1">*</span>}
            </label>
            <div className="relative">
                {Icon && (
                    <div className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none">
                        <Icon />
                    </div>
                )}
                <input
                    id={name}
                    name={name}
                    type={type}
                    placeholder={placeholder}
                    value={value}
                    onChange={onChange}
                    className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-400"
                    autoComplete="off"
                />
            </div>
        </div>
    );
};

export default InputField;
